document.addEventListener('DOMContentLoaded', function() {
  var mediaGalleries = document.querySelectorAll('media-gallery');
  if (mediaGalleries.length) {
    mediaGalleries.forEach(function(gallery) {
      gallery.setAttribute('data-enable-variant-group-images', 'true');
    });
  }

  function moveBogoBadges() {
    var badges = document.querySelectorAll('.sca-gift-icon-collection-page');
    badges.forEach(function(badge) {
      var card = badge.closest('.m-product-card');
      if (!card) return;
      var media = card.querySelector('.m-product-card__media');
      if (!media) return;
      if (badge.parentElement === media) return;
      media.appendChild(badge);
    });
  }

  moveBogoBadges();

  var observer = new MutationObserver(function(mutations) {
    var shouldRun = mutations.some(function(m) {
      return Array.from(m.addedNodes).some(function(n) {
        return n.nodeType === 1 && (
          n.classList && n.classList.contains('sca-gift-icon-collection-page') ||
          n.querySelector && n.querySelector('.sca-gift-icon-collection-page')
        );
      });
    });
    if (shouldRun) moveBogoBadges();
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
